module.exports = __webpack_public_path__ + "img/18_1.34a21be0.png";